import gql from 'graphql-tag';
import { deleteResultFragment } from '../fragments/delete-result.fragment';

export const leaveGroupMutation = gql`
  mutation leaveGroup($groupID: ID!) {
    leaveGroup(groupID: $groupID) {
      ...deleteResultFragment
    }
  }
  ${deleteResultFragment}
`;
